import {Image} from 'react-native';

import styled from '../../../lib/utils/styled';

export const DeviceSupportHeader = styled(Image)({
  width: '100%',
  aspectRatio: 1.6,
  resizeMode: 'cover',
});
